import { GrClose } from 'react-icons/gr';
import { useNavigate } from 'react-router-dom';
import './styles.css';

function EventsModal(props) {
    const { content, title, copyright, link, setOpen } = props;
    const navigate = useNavigate();

    const handleClose = () => {
        if (setOpen) {
            setOpen(false);
        } else {
            navigate('/evento');
        }
    };

    return (
        <>
            <div className="event-modal-background" onClick={handleClose} />
            <div className="event-modal" role="dialog" aria-labelledby="modal-title" aria-modal="true">
                <GrClose className='close-icon' onClick={handleClose} aria-label="Fechar modal" />
                <h2 id="modal-title" className='case-modal-title'>{title}</h2>
                <div className='content-section'>
                    {content.map((item, index) => {
                        if (item.type === 'image') {
                            const images = Array.isArray(item.src) ? item.src : [item.src];
                            return (
                                <div key={index} className="modal-image-gallery">
                                    {images.map((src, imgIndex) => (
                                        <img
                                            key={imgIndex}
                                            src={src}
                                            alt={item.alt || 'Imagem do evento'}
                                            className="gallery-img"
                                        />
                                    ))}
                                </div>
                            );
                        } else if (item.type === 'text') {
                            return (
                                <p key={index} className="modal-text">{item.text}</p>
                            );
                        } else if (item.type === 'link') {
                            return (
                                <div key={index} className="link-section">
                                    <a
                                        href={item.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="event-link"
                                    >
                                        {item.text || item.url}
                                    </a>
                                </div>
                            );
                        }
                        return null;
                    })}
                    {link && (
                        <div className="event-links">
                            <h3>Links:</h3>
                            <ul>
                                {Array.isArray(link) ? (
                                    link.map((linkItem, idx) => (
                                        <li key={idx}>
                                            <a href={linkItem.url} target="_blank" rel="noopener noreferrer">
                                                {linkItem.text}
                                            </a>
                                        </li>
                                    ))
                                ) : (
                                    <li>
                                        <a href={link.url} target="_blank" rel="noopener noreferrer">
                                            {link.text}
                                        </a>
                                    </li>
                                )}
                            </ul>
                        </div>
                    )}
                </div>
                {copyright && <p className='copyright'>{copyright}</p>}
            </div>
        </>
    );
}

export default EventsModal;
